define(['moduler'], function (Moduler) {
	'use strict';

	return Moduler.create({
		defaults: {
			template: '<a href="#" class="ScrollToTop" title="Scroll to the top"></a>',
			topThreshold: 150, // how far from top to display the button
			offsetBottom: '.Status--fixedBottom' // use a selector to offset the reference from the bottom by the height of the elements
		},

		init: function () {
			var self = this;
			var scroller = Moduler.utils.bind(self.onScroll, self);
			window.addEventListener('scroll', function () {
				(window.requestAnimationFrame && requestAnimationFrame(scroller)) || setTimeout(scroller, 1000 / 60);
			});

			if (window.scrollY >= self.options.topThreshold) {
				(window.requestAnimationFrame && requestAnimationFrame(scroller)) || setTimeout(scroller, 1000 / 60);
			}
		},

		ensureExists: function () {
			var self = this;
			if (!document.querySelector('.ScrollToTop')) {
				self.exists = false;
				self.isShown = false;
			}
			if (!self.exists) {
				document.body.insertAdjacentHTML("beforeend", self.options.template);

				document.querySelector('.ScrollToTop').addEventListener('click', function (e) {
					e.preventDefault();
					window.scrollTo({
						top: 0,
						behavior: "smooth"
					});
				});

				self.exists = true;
			}
		},

		onScroll: function () {
			var self = this;

			self.ensureExists();
			var scrollButton = document.querySelector('.ScrollToTop');
			if (!scrollButton) {
				return;
			}

			if (window.scrollY >= self.options.topThreshold) {
				if (window.innerWidth < 768) {
					var notice = document.querySelector('.Status--visitorNotice');
					if (notice && (notice.offsetWidth > 0 || notice.offsetHeight > 0)) {
						scrollButton.classList.add('ScrollToTop--withinNotice');
						notice.appendChild(scrollButton);
					}
				}
				if (!self.isShown) {
					self.ensureExists();
					let elem = document.querySelector('.ScrollToTop');

					if (self.options.offsetBottom?.length > 0) {
						let offsetBottom = 0;
						document.querySelectorAll(self.options.offsetBottom).forEach(o => {
							offsetBottom += o.getBoundingClientRect().height;
						});
						elem.style.bottom = offsetBottom + 'px';
					}

					elem.classList.add('is-shown');
					self.isShown = true;
				}
			} else {
				if (self.isShown) {
					if (window.innerWidth < 768) {
						scrollButton.classList.remove('ScrollToTop--withinNotice');
						document.body.appendChild(scrollButton);
					}
					document.querySelector('.ScrollToTop').classList.remove('is-shown');
					self.isShown = false;
				}
			}
		}
	});
});